import _ from 'lodash';
import { useEffect } from 'react';
import api from '~/services/api';
import useGlobalContext from '~/view-data/use-global-context';
import useHeader from './use-header';
import useFetch from '~/view-data/use-fetch';
import { showMessage } from '~/helper';

const initialState = {
  loading: false,
  model: {},
};

const useCheckout = () => {
  const {
    state: { checkout = initialState },
    dispatch,
  } = useGlobalContext();
  const { actions: headerActions } = useHeader();

  useEffect(() => {
    return () => {
      dispatch({ type: 'checkout', payload: { model: {}, loading: false } });
    };
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    headerActions.configure({
      title: 'Check-out',
      loading: _.get(checkout, 'loading', false),
    });
    // eslint-disable-next-line
  }, [checkout]);

  const { data, mutate } = useFetch({
    url: 'checkout/employees',
    params: { eventId: _.get(checkout, 'model.event.id') }
  });

  const failure = (error) => {
    dispatch({ type: 'checkout', payload: { loading: false } });
    showMessage('error', error);
  };

  const isSelectedEvent = () => {
    const event = _.get(checkout, 'model.event');
    return !_.isEmpty(event);
  };

  const eventsFinding = async (term, callback) => {
    try {
      const { data } = await api.get(`checkout/events-finding`, { params: { term } });
      callback(data);
    } catch (error) {
      failure(error, dispatch);
    }
  };

  const selectEvent = (event) => {
    dispatch({ type: 'checkout', payload: { model: { event } } });
  };

  const checkoutByCredentialNumber = async (value) => {
    try {
      dispatch({ type: 'checkout', payload: { loading: true } });

      const eventId = _.get(checkout, 'model.event.id');
      const { data } = await api.get(`checkout/make`, {
        params: { eventId, credentialNumber: value },
      });

      dispatch({
        type: 'checkout',
        payload: { model: { ...checkout.model, employee: data } },
      });

      mutate(data);
    } catch (error) {
      failure(error, dispatch);
    } finally {
      dispatch({ type: 'checkout', payload: { loading: false } });
    }
  };

  return {
    state: {
      ...checkout,
      data: _.isEmpty(data) ? [] : data,
    },
    actions: {
      isSelectedEvent,
      eventsFinding,
      selectEvent,
      checkoutByCredentialNumber,
    },
  };
};

export default useCheckout;
